/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["file-entries-page{display:block}file-entries-page .mat-column-owner img{width:35px;height:35px;margin-right:8px}file-entries-page .mat-column-file_name{margin:0 30px;min-width:330px}file-entries-page .mat-column-public,file-entries-page .mat-column-type{max-width:90px}file-entries-page .mat-column-file_size{max-width:140px}"];
export { styles as styles };
